export const UNIAPA_LOCAL_STORAGE_KEY = 'uniapa';

export const SPOTLIGHT_LOCAL_STORAGE_ITEM_KEY = 'has-spotlight-been-shown';

export const SPOTLIGHT_MESSAGE_ID = 'jira-admin-product-request-spotlight';
